// 读取并规范化环境值（去掉可能包含的引号）
const getEnv = () => {
  const raw = VE_ENV?.VITE_APP_ENV ?? 'development';
  return String(raw).replace(/^"|"$/g, '');
};

// 根据环境变量获取服务器地址
const getServerUrl = () => {
  const env = getEnv();
  switch (env) {
    case 'production':
      // return "https://birdseye-api.feiniaotech.sysuimars.cn/";
      return "https://feiniaotech-dev.sysuimars.cn/";
    case 'test':
      return "https://feiniaotech-test.sysuimars.cn/";
    case 'local':
      return "http://127.0.0.1:81/";
      // return "https://feiniaotech-dev.sysuimars.cn/";
    case 'henan':
      return "http://henan.feiniaotech.com:20011/feiniao-api/";
    case 'development':
    default:
      return "https://feiniaotech-dev.sysuimars.cn/";
  }
};

// 根据环境变量获取天气服务器地址
const getWeatherServerUrl = () => {
  const env = getEnv();
  switch (env) {
    case 'production':
      return "https://weather-api.feiniaotech.sysuimars.cn/";
    case 'test':
      return "https://weather-api-test.feiniaotech.sysuimars.cn/";
    case 'local':
      // return "http://127.0.0.1:82/";
      return "https://weather-api.feiniaotech.sysuimars.cn/";
    case 'henan':
      return "http://henan.feiniaotech.com:20011/weather-api/";
    case 'development':
    default:
      return "https://weather-api.feiniaotech.sysuimars.cn/";
  }
};

const getOneMapServerUrl = () => {
  const env = getEnv();
  switch (env) {
    case 'production':
      return "https://one-map-api.feiniaotech.com/";
    case 'test':
      return "https://one-map-api.feiniaotech.com/";
    case 'local':
      return "http://127.0.0.1:84/";
    case 'henan':
      return "https://one-map-api.feiniaotech.com/";
    case 'development':
    default:
      return "https://one-map-api.feiniaotech.com/";
  }
};

const server = getServerUrl();
const weather_server = getWeatherServerUrl();
const onemap_server = getOneMapServerUrl()

export const base_url = server + "site/";
export const onemapbase_url = onemap_server + "site/";
export const base_mini_url = server + "mini/";
export const weather_base_url = weather_server + "site/";
export const base_img = getEnv() !== 'henan' ? 'https://birdseye-img-ali-cdn.sysuimars.com/' : 'http://henan-minio.feiniaotech.com:20011/feiniao/';
export const base_img_url3 = "https://birdseye-img.sysuimars.com/";

//获取请求头中的参数体
export const getOptBody = (opt) => {
    return JSON.parse(opt.body);
}

// 默认导出，保持向后兼容
export default {
    onemapbase_url,
    base_url,
    base_mini_url,
    weather_base_url,
    base_img,
    base_img_url3,
    getOptBody
}
